// converts date to dd.mm.yyyy
const getDateString = date => {
  return date
    .toISOString()
    .substring(0, 10)
    .split("-")
    .reverse()
    .join(".");
};

export { getDateString };
